import { createSlice } from '@reduxjs/toolkit';
import { fetchPersonChannels } from './personChannelThunks';
import type { PersonChannelState } from './personChannelTypes';

const initialState: PersonChannelState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

/**
 * Slice read-only: niente create/update/remove (backend non li espone).
 * `byId` viene popolato solo da fetchPersonChannels.fulfilled.
 */
export const personChannelSlice = createSlice({
  name: 'personChannels',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPersonChannels.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPersonChannels.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        for (const item of action.payload.items) state.byId[item.personChannelId] = item;
      })
      .addCase(fetchPersonChannels.rejected, (state, action) => {
        state.status = 'failed';
        state.error = (action.payload as string) ?? null;
      });
  },
});

export const personChannelReducer = personChannelSlice.reducer;
